import { Box, Center, HStack, Text } from '@chakra-ui/react'

import { AiFillCopyrightCircle } from 'react-icons/ai'

const Footer = () => {
  return (
    <Center> <AiFillCopyrightCircle /> <Text>2022 All rights reserved.</Text></Center>
  )
}

export default Footer